<template>
  <div class="bg-F9 rc-tree-wrapper">
    <div class="pl-4 pr-4 mt-4 mb-4">
      <el-input
        v-model="treeSearchWord"
        placeholder="搜索"
        clearable
        @keyup.enter.native="filterTree"
        @input="filterTree"
        @clear="filterTree"
      >
        <i slot="suffix" class="pr-1" @click="filterTree">
          <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
        </i>
      </el-input>
    </div>
    <div v-if="showTitle" class="flex justify-between items-end mb-4">
      <div class="pl-4">
        <span class="vertical-bar fnM">{{ title }}</span>
        <el-checkbox v-if="showStrictly" v-model="strictly" :disabled="!multi" size="mini" class="ml-4">父子联动</el-checkbox>
      </div>

      <div class="pr-4 sicm-sub-text-color text-gray-901 text-xs">
        <span class="cursor-pointer hover:text-primary" @click="expandTree(true)">展开</span>
        <span class="pr-2 pl-2">|</span>
        <span class="cursor-pointer hover:text-primary" @click="expandTree(false)">收起</span>
      </div>
    </div>
    <div class="overflow-y-scroll pb-1 tree-height">
      <el-tree
        ref="rcTree"
        node-key="id"
        class="rc-tree-content self-tree"
        v-bind="$attrs"
        :check-strictly="!strictly"
        :expand-on-click-node="false"
        :data="treeData"
        :highlight-current="true"
        :current-node-key="currentNodeKey"
        :filter-node-method="filterNode"
        @check-change="checkChange"
        @check="nodeCheck"
        v-on="$listeners"
      >
        <template v-for="(index, name) in $scopedSlots" #[name]="slotScope">
          <slot :name="name" v-bind="slotScope"></slot>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { commonFilterNode } from "@/utils";
export default {
  name: "RcTree",
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      default: () => []
    },
    currentNodeKey: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: "组织树"
    },
    // 显示父子联动，默认不联动
    showStrictly: {
      type: Boolean,
      default: false
    },
    // 是否可以多选，不能多选的情况下需要禁用父子联动
    multi: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      treeSearchWord: "",
      strictly: !this.showStrictly
    };
  },
  watch: {
    currentNodeKey(id) {
      this.$nextTick(() => {
        id && this.$refs.rcTree.setCurrentKey(id);
      });
    }
  },
  methods: {
    expandTree(expand) {
      // 获取tree节点的所有数据信息
      const { nodesMap } = this.$refs.rcTree.store;

      // 展开收起
      for (const key in nodesMap) {
        nodesMap[key].expanded = expand;
      }
    },
    filterTree() {
      this.$refs.rcTree.filter(this.treeSearchWord);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    checkChange(node, isCheck) {
      // 非父子联动情况
      if (!this.strictly && this.multi) {
        // 选中则设置父为选中
        isCheck && this.collectionParentKeys(node, this.treeData).forEach(key => this.setChecked(key, true));
        // 取消选中则设置子为未选中
        !isCheck && this.collectionChildrenKeys(node.children).forEach(key => this.setChecked(key, false));
      }

      this.$emit("treeCheckChange", {
        checkedNodes: this.$refs.rcTree.getCheckedNodes(),
        halfCheckedNodes: this.$refs.rcTree.getHalfCheckedNodes()
      });
    },
    // 处理单选逻辑
    nodeCheck(node, { checkedKeys, halfCheckedKeys }) {
      // 不支持多选
      if (!this.multi) {
        [...checkedKeys, ...halfCheckedKeys].forEach(key => this.setChecked(key, false));
      }

      this.setChecked(node.id, true);
    },
    // 清空选中
    clearSelected() {
      const nodes = [...this.$refs.rcTree.getCheckedNodes(), this.$refs.rcTree.getHalfCheckedNodes()];
      nodes.forEach(node => this.setChecked(node.id, false));
    },
    // 设置选中状态
    setChecked(...args) {
      return this.$refs.rcTree.setChecked(...args);
    },
    // 收集父级keys
    collectionParentKeys(node, data, keys = []) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        // 找到直接return
        if (item.id === node.id) {
          return keys;
        }
        keys.push(item.id);

        if (Array.isArray(item.children)) {
          const findKeys = this.collectionParentKeys(node, item.children, keys);

          // 找到keys
          if (findKeys.length) {
            return findKeys;
          }
        }

        // 均未找到
        keys.pop();
      }

      return [];
    },
    // 收集子级keys
    collectionChildrenKeys(nodes, keys = []) {
      if (Array.isArray(nodes)) {
        for (let i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          keys.push(node.id);

          if (Array.isArray(node.children)) {
            this.collectionChildrenKeys(node.children, keys);
          }
        }
      }
      return keys;
    }
  }
};
</script>

<style lang="scss" scoped>
  .tree-height {
    height: 516px;
  }
  .rc-tree-wrapper {
    .rc-tree-content {
      background: transparent;
    }
  }
</style>
